export const purchaseOrdersTranslations = {
  ar: {
    title: 'أوامر الشراء',
    addNew: 'إضافة أمر شراء جديد',
    newOrder: 'أمر شراء جديد',
    editOrder: 'تعديل أمر الشراء',
    branch: 'الفرع',
    vendor: 'المورد',
    date: 'التاريخ',
    deliveryDate: 'تاريخ التسليم',
    referenceNumber: 'رقم المرجع',
    paymentMethod: 'طريقة الدفع',
    cashAccount: 'حساب الخزينة',
    notes: 'ملاحظات',
    items: 'الأصناف',
    addItem: 'إضافة صنف',
    configureColumns: 'إعدادات الأعمدة',
    totalDiscount: 'الخصم الكلي',
    totalTax: 'الضريبة الكلية',
    grandTotal: 'الإجمالي النهائي',
    cancel: 'إلغاء',
    save: 'حفظ',
    update: 'تحديث',
    status: 'الحالة',
    open: 'مفتوح',
    partiallyReceived: 'مستلم جزئياً',
    fullyReceived: 'مستلم بالكامل',
    actions: 'الإجراءات',
    serial: 'الرقم التسلسلي',
    orderSerial: 'رقم الأمر',
    receive: 'استلام',
    convertToPurchaseInvoice: 'تحويل إلى فاتورة شراء',
    convertSuccess: 'تم تحويل طلبية الشراء إلى فاتورة شراء بنجاح',
    convertError: 'فشل تحويل طلبية الشراء إلى فاتورة شراء',
    convertConfirm: 'هل أنت متأكد أن الطلبية جاهزة؟ سيتم تحويلها إلى فاتورة شراء (مسودة) للمراجعة ثم الترحيل.',
    createReceipt: 'إنشاء إشعار استلام',
    receiptDate: 'تاريخ الاستلام',
    itemsToReceive: 'الأصناف المراد استلامها',
    ordered: 'المطلوب',
    received: 'المستلم سابقاً',
    remaining: 'المتبقي',
    receiveNow: 'استلام الآن',
    saveReceipt: 'حفظ الإشعار',
    receiveAll: 'استلام الكل',
    poInformation: 'معلومات أمر الشراء',
    poNumber: 'رقم أمر الشراء',
    receiptSuccess: 'تم إنشاء إشعار الاستلام بنجاح',
    receiptError: 'خطأ في إنشاء إشعار الاستلام',
    atLeastOneQty: 'يجب إدخال كمية مستلمة واحدة على الأقل',
    qtyExceedsRemaining: 'الكمية المستلمة تتجاوز الكمية المتبقية',
    receiptDateRequired: 'تاريخ الاستلام مطلوب',
    notesPlaceholder: 'أدخل أي ملاحظات إضافية هنا...',
    notSpecified: 'غير محدد',
    product: 'الصنف',
    unit: 'الوحدة',
    quantity: 'الكمية',
    price: 'السعر',
    percentageDiscount: 'خصم نسبة',
    cashDiscount: 'خصم نقدي',
    tax: 'الضريبة',
    netBeforeTax: 'الصافي قبل الضريبة',
    net: 'الصافي',
    barcode: 'الباركود',
    totals: 'الإجماليات',
  },
  en: {
    title: 'Purchase Orders',
    addNew: 'Add New Purchase Order',
    newOrder: 'New Purchase Order',
    editOrder: 'Edit Purchase Order',
    branch: 'Branch',
    vendor: 'Vendor',
    date: 'Date',
    deliveryDate: 'Delivery Date',
    referenceNumber: 'Reference Number',
    paymentMethod: 'Payment Method',
    cashAccount: 'Cash Account',
    notes: 'Notes',
    items: 'Items',
    addItem: 'Add Item',
    configureColumns: 'Configure Columns',
    totalDiscount: 'Total Discount',
    totalTax: 'Total Tax',
    grandTotal: 'Grand Total',
    cancel: 'Cancel',
    save: 'Save',
    update: 'Update',
    status: 'Status',
    open: 'Open',
    partiallyReceived: 'Partially Received',
    fullyReceived: 'Fully Received',
    actions: 'Actions',
    serial: 'Serial',
    orderSerial: 'Order Serial',
    receive: 'Receive',
    convertToPurchaseInvoice: 'Convert to Purchase Invoice',
    convertSuccess: 'Purchase order converted to purchase invoice successfully',
    convertError: 'Failed to convert purchase order to purchase invoice',
    convertConfirm: 'Confirm this purchase order is ready? It will be converted to a draft purchase invoice for review, then posting.',
    createReceipt: 'Create Goods Receipt',
    receiptDate: 'Receipt Date',
    itemsToReceive: 'Items to Receive',
    ordered: 'Ordered',
    received: 'Received',
    remaining: 'Remaining',
    receiveNow: 'Receive Now',
    saveReceipt: 'Save Receipt',
    receiveAll: 'Receive All',
    poInformation: 'Purchase Order Information',
    poNumber: 'PO Number',
    receiptSuccess: 'Goods receipt created successfully',
    receiptError: 'Error creating goods receipt',
    atLeastOneQty: 'You must enter at least one received quantity',
    qtyExceedsRemaining: 'Received quantity exceeds remaining quantity',
    receiptDateRequired: 'Receipt date is required',
    notesPlaceholder: 'Enter any additional notes here...',
    notSpecified: 'Not specified',
    product: 'Product',
    unit: 'Unit',
    quantity: 'Quantity',
    price: 'Price',
    percentageDiscount: 'Percentage Discount',
    cashDiscount: 'Cash Discount',
    tax: 'Tax',
    netBeforeTax: 'Net Before Tax',
    net: 'Net',
    barcode: 'Barcode',
    totals: 'Totals',
  },
  fr: {
    title: 'Bons de Commande',
    addNew: 'Ajouter un Nouveau Bon de Commande',
    newOrder: 'Nouveau Bon de Commande',
    editOrder: 'Modifier le Bon de Commande',
    branch: 'Succursale',
    vendor: 'Fournisseur',
    date: 'Date',
    deliveryDate: 'Date de livraison',
    referenceNumber: 'Numéro de référence',
    paymentMethod: 'Méthode de paiement',
    cashAccount: 'Compte de trésorerie',
    notes: 'Notes',
    items: 'Articles',
    addItem: 'Ajouter un article',
    configureColumns: 'Configurer les colonnes',
    totalDiscount: 'Remise totale',
    totalTax: 'Taxe totale',
    grandTotal: 'Total général',
    cancel: 'Annuler',
    save: 'Enregistrer',
    update: 'Mettre à jour',
    status: 'Statut',
    open: 'Ouvert',
    partiallyReceived: 'Reçu partiellement',
    fullyReceived: 'Entièrement reçu',
    actions: 'Actions',
    serial: 'Série',
    orderSerial: 'Série de commande',
    receive: 'Recevoir',
    convertToPurchaseInvoice: 'Convertir en facture d\'achat',
    convertSuccess: 'Bon de commande converti en facture d\'achat avec succès',
    convertError: 'Échec de la conversion du bon de commande en facture d\'achat',
    convertConfirm: 'Confirmer que le bon de commande est prêt ? Il sera converti en facture d\'achat (brouillon) pour révision puis validation.',
    createReceipt: 'Créer un bon de réception',
    receiptDate: 'Date de réception',
    itemsToReceive: 'Articles à recevoir',
    ordered: 'Commandé',
    received: 'Reçu précédemment',
    remaining: 'Restant',
    receiveNow: 'Recevoir maintenant',
    saveReceipt: 'Enregistrer le bon',
    receiveAll: 'Tout recevoir',
    poInformation: 'Informations sur le bon de commande',
    poNumber: 'Numéro de BC',
    receiptSuccess: 'Bon de réception créé avec succès',
    receiptError: 'Erreur lors de la création du bon de réception',
    atLeastOneQty: 'Vous devez saisir au moins une quantité reçue',
    qtyExceedsRemaining: 'La quantité reçue dépasse la quantité restante',
    receiptDateRequired: 'La date de réception est requise',
    notesPlaceholder: 'Saisissez des notes supplémentaires ici...',
    notSpecified: 'Non spécifié',
    product: 'Produit',
    unit: 'Unité',
    quantity: 'Quantité',
    price: 'Prix',
    percentageDiscount: 'Remise pourcentage',
    cashDiscount: 'Remise espèce',
    tax: 'Taxe',
    netBeforeTax: 'Net hors taxe',
    net: 'Net',
    barcode: 'Code-barres',
    totals: 'Totaux',
  }
}
